import shuffle from './shuffle';

/**
 * @function generateDeck
 * @description Generate a deck of a (random) (total) number of cards
 * @param {Array} deck The deck definition object
 * @param {number} total
 * @param {number} random
 * @returns
 */
export default function generateDeck(deck, total, random) {
    if (random) deck = shuffle(deck);
    return deck.slice(0, total);
}
